import React from 'react';

import { Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { BodyStyles } from './Body.styles';
import type { FacebookStoryComponentsProps } from './types';

export function Body(props: FacebookStoryComponentsProps): React.JSX.Element {
	const { size, loading, previewImageUrl } = props;

	const styles = BodyStyles({ size });

	if (loading) {
		if (size === 'xsmall') {
			return (
				<SkeletonContainer loading={loading} className="h-full w-full" data-testid="empty-container">
					<Rectangle className="h-full w-full" />
				</SkeletonContainer>
			);
		}
		return (
			<SkeletonContainer
				loading={loading}
				className={styles}
				shapeColorClassName="bg-icon-weak"
				data-testid="empty-container"
			>
				<Rectangle className="h-full w-full" />
			</SkeletonContainer>
		);
	}

	return <img data-testid="body-image" className={styles} src={previewImageUrl} alt="" aria-hidden />;
}
